<div class="container">
    <div class="center">
        <button mat-raised-button class="login-button" (click)="beginLoginProcess()">Login with Okta</button>
    </div>
</div>
